import React from "react";
import { Link } from "react-router-dom";
import MainButton from "../../Elements/MainButton/MainButton";
import emptySimIcon from "../../../assets/cart/sim-card.png";

import "./EmptyEsimView.css";

const EmptyEsimView = () => (
  <div className="esim-empty-container">
    <section className="esim-empty-content">
      <img src={emptySimIcon} alt="No eSIMs" className="esim-empty__img" aria-hidden="true" />
      <h2 className="esim-empty__title">No eSIMs Yet</h2>
      <p className="esim-empty__lead">
        Purchase your first eSIM profile to start connecting globally. It only takes a few minutes!
      </p>
      <Link to="/shop" className="esim-empty__cta">
        <MainButton type="button">Buy your first eSIM</MainButton>
      </Link>
    </section>
  </div>
);

export default EmptyEsimView;
